var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrowingBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_186984",
    "data-name": "Group 186984",
    transform: "translate(21364 1693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75298",
    "data-name": "Path 75298",
    d: "M4.137,451.841a.591.591,0,0,0-.591-.591H.591a.591.591,0,0,0-.591.591v4.768a.591.591,0,0,0,.591.591H3.546a.591.591,0,0,0,.591-.591Zm0,0",
    transform: "translate(-21364 -2130.2)",
    fill: "#7d96ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75299",
    "data-name": "Path 75299",
    d: "M173.546,338.75h-2.955a.591.591,0,0,0-.591.591v8.314a.591.591,0,0,0,.591.591h2.955a.591.591,0,0,0,.591-.591v-8.314A.591.591,0,0,0,173.546,338.75Zm0,0",
    transform: "translate(-21528.699 -2021.246)",
    fill: "#7d96ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75300",
    "data-name": "Path 75300",
    d: "M342.3,301.25h-2.955a.591.591,0,0,0-.591.591v9.5a.591.591,0,0,0,.591.591H342.3a.591.591,0,0,0,.591-.591v-9.5A.591.591,0,0,0,342.3,301.25Zm0,0",
    transform: "translate(-21692.188 -1984.928)",
    fill: "#7d96ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75301",
    "data-name": "Path 75301",
    d: "M512.3,151.25h-2.955a.591.591,0,0,0-.591.591v14.224a.591.591,0,0,0,.591.591H512.3a.591.591,0,0,0,.591-.591V151.841A.591.591,0,0,0,512.3,151.25Zm0,0",
    transform: "translate(-21856.887 -1839.656)",
    fill: "#7d96ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75302",
    "data-name": "Path 75302",
    d: "M12.382,13a1.75,1.75,0,0,0,1.685-2.249l2.282-1.626a1.731,1.731,0,0,0,1.012.329,1.759,1.759,0,0,0,1.734-1.537l2.337-.5a1.749,1.749,0,0,0,1.494.852,1.771,1.771,0,0,0,1.626-2.441l2.8-2.514a1.724,1.724,0,0,0,.843.227,1.776,1.776,0,1,0-1.626-1.105l-2.8,2.514a1.724,1.724,0,0,0-.843-.227,1.759,1.759,0,0,0-1.734,1.537l-2.337.5a1.749,1.749,0,0,0-1.494-.852,1.75,1.75,0,0,0-1.685,2.249L13.394,9.785a1.731,1.731,0,0,0-1.012-.329,1.773,1.773,0,0,0,0,3.546Zm0,0",
    transform: "translate(-21374.291 -1693)",
    fill: "#7d96ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowingBars);
export default __webpack_public_path__ + "static/media/growingBars.f9ded91dbad222e69467e7f70c659842.svg";
export { ForwardRef as ReactComponent };